export default __webpack_public_path__ + "static/media/szastaz.b8ffaf6a.png";